import { IPortalFolder } from '@interfaces/portal/folders';

export const checkFolderExists = (foldersList: IPortalFolder[], folderId: string): boolean => {
	const stack: IPortalFolder[] = [...foldersList];

	while (stack.length) {
		const current = stack.pop();
		if (!current) continue;

		if (current.id === folderId) {
			return true;
		}

		if (current.subfolders && current.subfolders.length > 0) {
			stack.push(...current.subfolders);
		}
	}

	return false;
};

export const getFolderByFolderId = (foldersList: IPortalFolder[], folderId: string): IPortalFolder | undefined => {
	let stack: IPortalFolder[] = [...foldersList];

	while (stack.length) {
		const current = stack.pop();

		if (!current) {
			continue;
		}

		if (current.id === folderId) {
			return current;
		}

		if (current.subfolders) {
			stack = stack.concat(current.subfolders);
		}
	}
};
